var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
		_vm.$s.LayoutContainer,
		( _obj = {}, _obj[_vm.$s.disabled] = _vm.disabled, _obj )
	]},[_c('div',{class:_vm.$s.ControlAligner},[_vm._t("control")],2),_vm._v(" "),_c('div',[_vm._t("label"),_vm._v(" "),(_vm.$slots.sublabel)?_c('div',[_vm._t("sublabel")],2):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }